// @flow
import * as React from 'react';
import { useStore } from 'react-redux';

import type { Reducer } from './Reducers';
import { injectReducers } from './helper';

const withReducers = (reducers: {
    [string]: Reducer
}): (<T>(React.AbstractComponent<T>) => React.AbstractComponent<T>) => {
    return function HOC<T>(
        Component: React.AbstractComponent<T>
    ): React.AbstractComponent<T> {
        return function ReducerWrappedComponent(props) {
            const [injected, setInjected] = React.useState(false);
            const store = useStore();
            React.useEffect(() => {
                injectReducers(store, reducers);
                setInjected(true);
            }, [store]);
            if (!injected) return null;
            return <Component {...props} />;
        };
    };
};

export default withReducers;
